<payarc-dialog-shell title="Profile" (closed)="dialogRef.close()">
  <ng-container *ngIf="topErrorMessage && show">
    <payarc-inline-alert variant="bad" *ngFor="let obj of keys1">
      <div *ngFor="let value of obj">{{ value }}</div>
    </payarc-inline-alert>
  </ng-container>
  <payarc-inline-alert variant="bad" *ngIf="!topErrorMessage && errorMsg">{{ errorMsg }}</payarc-inline-alert>

  <mat-dialog-content class="pd-content">
    <form #createCustomer="ngForm" class="profile_form" autocomplete="off">
      <payarc-form-field label="Email" controlId="email" *ngIf="userEmail">
        <input class="pa-input" type="email" name="email" id="email" #email="ngModel" [(ngModel)]="userEmail" disabled>
      </payarc-form-field>

      <payarc-form-field label="Name" controlId="name" *ngIf="userName">
        <input class="pa-input" type="text" name="name" id="name" #name="ngModel" [(ngModel)]="userName" disabled>
      </payarc-form-field>

      <button type="button" payarcButton="secondary" class="pd-change-pw" (click)="showPasswordPanel(createCustomer)">Change password</button>

      <ng-container *ngIf="show">
        <payarc-form-field label="Current password" controlId="oldpassword">
          <input class="pa-input" type="password" name="oldpassword" id="oldpassword"
                 #oldpassword="ngModel" [(ngModel)]="current_password" autocomplete="new-password">
        </payarc-form-field>
        <payarc-form-field label="New password" controlId="newpassword">
          <input class="pa-input" type="password" name="newpassword" id="newpassword"
                 #newpassword="ngModel" [(ngModel)]="new_password" autocomplete="new-password">
        </payarc-form-field>
        <payarc-form-field label="Confirm password" controlId="confirmpassword">
          <input class="pa-input" type="password" name="confirmpassword" id="confirmpassword"
                 #confirmpassword="ngModel" [(ngModel)]="new_password_confirmation" autocomplete="new-password">
        </payarc-form-field>
      </ng-container>

      <div class="pd-section" [formGroup]="verifyForm">
        <payarc-section-title label="2-Step Verification methods"></payarc-section-title>
        <div class="pd-row">
          <span class="pd-row__label">Email</span>
          <span [innerHTML]="this.user_data['email']"></span>
        </div>
        <div class="pd-row">
          <span class="pd-row__label">2FA Application</span>
          <button *ngIf="!this.user_data['has_2fa_enabled']" id="verify2FAApp" (click)="verify2FAApp()" class="update-btn">Set up 2FA Application</button>
          <button *ngIf="this.user_data['has_2fa_enabled']" id="disable2FAApp" (click)="disable2FAApp()" class="update-btn">Disable 2FA Application</button>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <div footer class="pd-footer">
    <button type="button" payarcButton="secondary" (click)="dialogRef.close(true)">Cancel</button>
    <app-loading-button [buttonText]="'Save'" [loadFlag]="loadFlag"
                         [disable]="(createCustomer.invalid || !show)"
                         (buttonClick)="onSaveClick(createCustomer)"></app-loading-button>
  </div>
</payarc-dialog-shell>
